import { css } from '@emotion/react'
import { memo } from 'react'
import useMedia from '~/hooks/useMedia'
import { fill_horizontal_cross_center } from '~/modules/AppLayout/FlexGridCss'
import { UserAvatarAsDialogButton } from '~/modules/auth/components/UserAvatarAsDialogButton'
import { ChartingServerSwitch } from '~/modules/SDK/chart4/components/ChartingServerSwitch'
import { Preset_Topbar } from '../heineken_template/_preset/preset_Topbar'
import { store } from '../heineken_template/_private/store'

export const Big3Stock_Topbar = memo<ReactProps>(function Big3Stock_Topbar() {
  const { isPc } = useMedia()

  return (
    <div
      css={css`
        ${fill_horizontal_cross_center};
        justify-content: end;
        background-color: #2a2e3b;
      `}
    >
      {isPc && <ChartingServerSwitch charting={store.charting} />}
      {isPc && <UserAvatarAsDialogButton />}
      {!isPc && (
        <Preset_Topbar
          showLeftBurger
          showRightBurger
          componentsInRight={
            <div
              css={css`
                ${fill_horizontal_cross_center};
                justify-content: end;
                background-color: #1f2c38;
              `}
            >
              <ChartingServerSwitch charting={store.charting} />
              <UserAvatarAsDialogButton />
            </div>
          }
        ></Preset_Topbar>
      )}
    </div>
  )
})
